import React from 'react';
import Content from '../../../../components/Content/Content';
import cx from 'classnames';
import styles from './Container.module.scss';
import { useUIContext } from '../../../../context/UIContext';

const Container = ({ children, innerRef = null }) => {

    const { miniSidebar } = useUIContext();

    return <Content innerRef={innerRef} className={cx(styles.editContent, { [styles.miniSidebar]: miniSidebar })}>
        {children}
    </Content>
}

export default Container;